import brand, { colourWithTransparency } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { keyframes } from 'styled-components';
import { ButtonStyles } from '../Buttons/GeneralButton/Button.styles';
const shimmer = keyframes `
  100% {
    transform: translateX(100%);
  }
`;
const Container = styled.section `
  position: relative;
  display: flex;
  height: 100%;
  box-shadow: 0 0 4px ${colourWithTransparency(brand.black, 0.25)};
  border-radius: 4px;
  text-decoration: none;
  flex-direction: column;
  padding: 20px;
  background-color: ${brand.white};

  ${ButtonStyles.Button} {
    margin-top: 24px;
    width: 100%;
  }
`;
const Title = styled.h3 `
  ${fonts.inter.extraBold};

  font-size: 14px;
  line-height: 26px;
  margin: 0 0 8px;

  @media ${from(Device.Tablet)} {
    font-size: 18px;
    line-height: 34px;
    margin: 0 0 16px;
  }
`;
const Metadata = styled.div `
  display: flex;
  flex-direction: column;
`;
const MetadataItem = styled.div `
  display: flex;
  align-items: center;
  margin: 0 0 16px;

  &:last-child {
    margin: 0;
  }
`;
const MetadataItemIcon = styled.span `
  display: block;
  flex: 22px 0 0;
  height: 22px;
  width: 22px;
`;
const MetadataItemValue = styled.span `
  ${fonts.sofiaPro.medium};
  font-size: 16px;
  line-height: 26px;
  margin-left: 8px;

  @media ${from(Device.Tablet)} {
    font-size: 18px;
    line-height: 28px;
  }
`;
const Date = styled.div `
  display: flex;
  flex-direction: column;
  margin: 24px 0 0;
`;
const DateLabel = styled.span `
  ${fonts.sofiaPro.medium};
  font-size: 16px;
  line-height: 26px;

  @media ${from(Device.Tablet)} {
    font-size: 16px;
    line-height: 24px;
  }
`;
const DateValue = styled.span `
  ${fonts.inter.extraBold};
  font-size: 16px;
  line-height: 26px;

  @media ${from(Device.Tablet)} {
    font-size: 18px;
    line-height: 28px;
  }
`;
const ModalIframe = styled.iframe `
  background: ${brand.white};
  height: 90vh;
  width: 90vw;
`;
const LoadingIndicator = styled.span `
  position: relative;
  display: inline-block;
  background: ${brand.grey.grey90};
  height: 1em;
  overflow: hidden;

  &[data-size='small'] {
    width: 40%;
  }

  &[data-size='medium'] {
    width: 60%;
  }

  &[data-size='full'] {
    width: 100%;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    animation: ${shimmer} 2s infinite;
    background: linear-gradient(
      to right,
      ${colourWithTransparency('#fff', 0)} 0%,
      ${colourWithTransparency('#fff', 0.2)} 20%,
      ${colourWithTransparency('#fff', 0.5)} 60%,
      ${colourWithTransparency('#fff', 0)} 100%
    );
    transform: translateX(-100%);
  }
`;
const VacancyCardStyles = {
    Container,
    Date,
    DateLabel,
    DateValue,
    LoadingIndicator,
    Metadata,
    MetadataItem,
    MetadataItemIcon,
    MetadataItemValue,
    ModalIframe,
    Title,
};
export default VacancyCardStyles;
